import Api from "../../lib/api";

export const getActions = (resource) => ({
  start: `fetch_start/pie_chart_data/${resource}`,
  success: `fetch_success/pie_chart_data/${resource}`,
  error: `fetch_error/pie_chart_data/${resource}`,
});

const fetchStart = (resource) => ({
  type: getActions(resource).start,
});

const fetchSuccess = (resource, data) => ({
  type: getActions(resource).success,
  data,
});

const fetchError = (resource, error) => ({
  type: getActions(resource).error,
  error,
});

const getResource = (resource) => (
  year,
  field_of_operation,
  sector_vocabulary
) => (dispatch) => {
  dispatch(fetchStart(resource));
  return Api.get(
    Api.API_PIE_CHART_DATA(year, field_of_operation, sector_vocabulary)
  )
    .then((response) => dispatch(fetchSuccess(resource, response.data)))
    .catch((error) => dispatch(fetchError(resource, error)));
};

const actions = {
  getPortalData: getResource("portal"),
  getSectorsData: getResource("sectors"),
  getSdgData: getResource("sgd"),
  getHomePortalsPieChartData: getResource("homePortals"),
  getHomeSdgsPieChartData: getResource("homeSdgs"),
  getHomeSectorsPieChartData: getResource("homeSectors"),
};

export default actions;



// WEBPACK FOOTER //
// ./shared/actions/getPieChartData.js